import {UrlParamHandler} from '@/components/UrlParamHandler';
import {HubspotProvider} from '@aaronhayes/react-use-hubspot-form';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {Provider} from 'react-redux';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/swiper-bundle.css';
import {STALE_TIME} from './api/utils';
import './App.scss';
import {trackUserViaCustomClientId} from './common/analytics-events';
import {CookieConsentBanner} from './components/CookieConsentBanner/CookieConsentBanner';
import './firebase/config'; // keep this to initialize analytics and other things right away
import store from './redux/store';
import {routes} from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      refetchOnWindowFocus: false,
    },
  },
});

trackUserViaCustomClientId();

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <Provider store={store}>
      <HubspotProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
          <UrlParamHandler />
          <CookieConsentBanner />
        </QueryClientProvider>
      </HubspotProvider>
    </Provider>
  );
}
